import './SubscriptionIcon.sass';

import React, { FC } from 'react';
import { SubscriptionIconProps } from '$shared/components/SubscriptionIcon/SubscriptionIcon.interface';
import { IcStar28 } from '$assets';
import { classNames as cn } from '$utils';
import { SubscriptionType } from '$store/models';
import { useUserInfo } from '$hooks';
import { UnitPhoto } from '$shared/components';

export const SubscriptionIcon: FC<SubscriptionIconProps> = (props) => {
  const { type, authorId, size = 'normal' } = props;
  const author = useUserInfo(authorId);

  if (type === SubscriptionType.Author && authorId > 0) {
    return (
      <div className={cn('SubscriptionIcon', size)}>
        <UnitPhoto
          onlineIndicator={size === 'large'}
          nftIndicator={size === 'large'}
          unit={author}
          size={size === 'normal' || size === 'list-icon' ? 'medium' : size}
        />
      </div>
    );
  }

  return (
    <div
      className={cn(size, {
        SubscriptionIcon: true,
        media: type === SubscriptionType.Media,
        adult: type === SubscriptionType.Adult,
        basic: type === SubscriptionType.Basic,
        authorCircle: type === SubscriptionType.Author,
      })}
    >
      <IcStar28 />
    </div>
  );
};
